import env from 'environments';
import offerImage from './ncc-funnel.png';

const isProduction = env.ENVIRONMENT === 'production';

const nccFunnel = {
  offerDescription: [
    'The entire 2-Step No Cold Calling Listing System.',
    'The Instant Trust Package.',
    'The Agent Comparison Chart.',
    'The editable 18-Step Marketing Plan.',
    'The Reference Letter Worksheet.',
    'The Introduction Cover Letter.',
    'The Photo Brochure that shows you’re an expert.',
    'The 60-Day Seller lead Follow Up Campaign.',
    'Complete A-to-Z Instructions on how to implement everything and start getting listings without cold calling.',
    'The Complete Guide to Finding Unlimited Leads.',
    'The Guide on how to Outsource Seller Lead Research to a VA.',
  ],
  productHandler: 'nccfunnel',
  componentId: 'handle:clickfunnel-1-99',
  summaryPrice: '$1.99',
  summaryTitle: '2-Step No Cold Calling Listing System',
  offerImage,
  upsell: {
    productHandler: 'monthly-with-trial-10',
    productPricePointHandle: 'monthly-with-trial-10',
    componentId: isProduction ? '1824463' : '2197555',
    offerId: isProduction ? '6504995bb8cad4bdeb9f2056' : '64e4ce1d8820dd81bbcebc6c',
  },
  USOnly: false,
};

export default nccFunnel;
